import _mergeJSXProps from './node_modules/@vue/babel-helper-vue-jsx-merge-props/dist/helper.mjs';

var BagSorryBgIcon = {
  name: 'BagSorryBgIcon',
  props: {},
  functional: true,
  render(h, ctx) {
    const attrs = ctx.data.attrs || {};
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      "attrs": {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 148 148"
      },
      "class": "c-ficon c-ficon--bag-sorry-bg"
    }, ctx.data]), [h("path", {
      "attrs": {
        "d": "M10.35 45.6s5.37 22.62 7.02 30.31c1.48 6.92 5.48 28.14 5.48 28.14s35.16.47 47.1.47c16.86 0 68.1-.47 68.1-.47S88.9 81.17 71.35 73.43c-15.13-6.68-61-27.83-61-27.83Z",
        "fill": "#C9ECF2"
      }
    }), h("path", {
      "attrs": {
        "d": "M59.4 91.42c-.56 2.69-.67 5.52-.9 8.24-.24 2.7-.4 5.79-.75 8.27-.16 1.13 1.58 1.62 1.74.48.37-2.74.53-5.51.77-8.27.23-2.75.31-5.55.87-8.24.24-1.13-1.5-1.61-1.73-.48ZM76.02 90.74c-.15 1.03-.06 2.1-.03 3.14.05 1.86.12 3.71.2 5.57a463.27 463.27 0 0 1 .24 7.72v.67c0 .1-.05.64 0 .27-.16 1.13 1.57 1.62 1.74.48.14-1.03.06-2.1.03-3.15-.05-1.85-.12-3.7-.19-5.56-.07-1.86-.15-3.77-.2-5.66-.02-.69-.04-1.38-.04-2.07v-.66c0-.1.05-.65 0-.27.16-1.14-1.57-1.63-1.74-.48Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m41.5 99.44 4.56-17.35 1.26-4.68 2.65-22.3 29.55-1 15.23 1.03-4.7 26.95-.15 16.78-16.28 1.77-32.11-1.2Z",
        "fill": "#fff"
      }
    }), h("path", {
      "attrs": {
        "d": "m49.97 55.1 6.1-.2-3.99 38.56-.97 6.46-9.6-.48 5.61-21.28 2.85-23.06Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "m81.15 53.74-2.3-4.97c-.5-1.05-2.04-.14-1.56.9l2.31 4.98c.49 1.05 2.04.13 1.55-.91Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M78.07 48.32a54.24 54.24 0 0 0-10.78-.07c-1.14.12-1.16 1.92 0 1.8 3.56-.37 7.22-.27 10.78.07 1.15.11 1.14-1.69 0-1.8Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M66.42 49.4a22.9 22.9 0 0 0 2.54 4.97c.66.94 2.22.04 1.55-.9a21.1 21.1 0 0 1-2.35-4.55c-.4-1.07-2.15-.6-1.74.48ZM74.25 53.67c-.27-1-.7-1.95-1.25-2.83-.64-.96-2.2-.06-1.55.91.47.74.83 1.55 1.07 2.4.32 1.11 2.06.64 1.73-.48Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M72.22 50.4c-3.44-.02-6.85-.44-10.3-.28-1.16.05-1.16 1.85 0 1.8 3.45-.16 6.86.26 10.3.28 1.16 0 1.16-1.8 0-1.8Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "m61.05 51.25 1.16 2.97c.18.45.6.77 1.11.63.43-.12.8-.65.63-1.1l-1.17-2.98c-.17-.45-.6-.76-1.1-.62-.43.12-.8.65-.63 1.1ZM54.37 55.13c-.4 2.16-.68 4.34-.83 6.53-.09 1.15 1.71 1.15 1.8 0 .14-2.03.4-4.05.77-6.05.2-1.13-1.53-1.62-1.74-.48ZM53.41 70.98c-.21 2.1-.49 4.18-.83 6.25-.19 1.14 1.54 1.62 1.73.48.37-2.23.67-4.48.9-6.73.12-1.16-1.68-1.15-1.8 0ZM51.7 85.52c-.1 1.33-.26 2.65-.48 3.96-.2 1.13 1.53 1.62 1.73.48.26-1.47.45-2.95.56-4.44.08-1.15-1.72-1.15-1.8 0ZM50.27 96.46c-.2.84-.25 1.7-.44 2.55-.26 1.13 1.47 1.6 1.73.48.2-.84.25-1.71.44-2.56.26-1.12-1.47-1.6-1.73-.47ZM68.15 59.5v.1c0 .08.01.16.05.23.02.08.07.15.12.2.06.06.13.1.2.12.07.04.15.06.23.06l.16-.03a.6.6 0 0 0 .27-.15l.1-.12a.6.6 0 0 0 .07-.3v-.11a.46.46 0 0 0-.05-.23.54.54 0 0 0-.31-.32.48.48 0 0 0-.24-.05l-.15.02a.6.6 0 0 0-.27.15l-.1.13c-.05.09-.08.2-.08.3ZM78.65 60.41c.77 0 .78-1.2 0-1.2-.77 0-.77 1.2 0 1.2Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M78.57 62.75a6 6 0 0 1 .42.3c.07.04-.04-.04 0 0l.05.03.1.09.2.17c.26.23.5.48.72.74.14.15.38.15.53 0a.39.39 0 0 0 0-.53 7.09 7.09 0 0 0-1.63-1.45.38.38 0 0 0-.51.14c-.1.18-.05.4.13.51ZM80.81 62.23l1.39 1.24a.37.37 0 0 0 .53-.53l-1.39-1.24a.37.37 0 1 0-.53.53ZM83.2 61.9l.42.41.5.54a.38.38 0 0 0 .53 0 .38.38 0 0 0 0-.53l-.5-.54-.42-.4a.37.37 0 1 0-.53.52ZM67.87 61.93c-.62.4-1.16.88-1.63 1.45a.4.4 0 0 0-.1.26.38.38 0 0 0 .63.27 6.6 6.6 0 0 1 .91-.92l.1-.07.05-.04c.05-.05-.04.02 0 0l.43-.3a.38.38 0 0 0-.38-.65h-.01ZM65.48 61.53l-1.39 1.24a.38.38 0 0 0 0 .53c.15.14.38.14.53 0L66 62.06a.38.38 0 0 0 0-.53.38.38 0 0 0-.53 0ZM63.1 61.1c-.16.17-.33.33-.51.48-.16.12-.31.27-.44.43a.4.4 0 0 0-.11.26c0 .1.04.2.1.27.08.07.17.11.27.11s.2-.04.27-.11c.13-.16.28-.3.44-.43.18-.15.35-.3.5-.48a.4.4 0 0 0 .12-.26.38.38 0 0 0-.64-.27Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M72.26 64.9c.22-.56 2.05-.62 2.07.07.01.58.91.58.9 0-.05-1.82-3.27-1.79-3.84-.3-.2.54.66.77.87.23ZM48.93 55.42l-2.89 23.26c-.15 1.22 1.77 1.21 1.92 0l2.89-23.26c.15-1.22-1.77-1.2-1.92 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M46 78.3c-1.85 6.95-3.68 13.9-5.42 20.88-.3 1.2 1.55 1.71 1.85.51 1.74-6.98 3.57-13.93 5.43-20.88.32-1.2-1.53-1.7-1.85-.5H46ZM49.97 56.06 79.15 55c1.23-.05 1.24-1.97 0-1.92l-29.18 1.07c-1.23.05-1.24 1.97 0 1.92Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M79.26 55.04c5.13.7 10.3 1.05 15.49 1.05 1.24 0 1.24-1.92 0-1.92-5.01.01-10.01-.32-14.98-.99-1.2-.16-1.73 1.69-.51 1.86ZM41.5 100.4c10.7.58 21.4.84 32.12.8 1.24 0 1.24-1.92 0-1.92a563.4 563.4 0 0 1-32.11-.8c-1.24-.07-1.24 1.85 0 1.92Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M73.62 101.2c5.44-.35 10.87-.73 16.28-1.37 1.2-.15 1.22-2.07 0-1.92-5.4.64-10.84 1.02-16.28 1.37-1.22.08-1.23 2 0 1.92ZM94.16 55.18a470.1 470.1 0 0 1-5.03 26.66c-.26 1.2 1.59 1.72 1.85.5 1.94-8.83 3.61-17.71 5.03-26.65.2-1.2-1.65-1.73-1.85-.51Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M89.01 81.98c.1 5.64.19 11.26-.07 16.9-.06 1.23 1.86 1.23 1.92 0 .26-5.64.16-11.26.07-16.9-.02-1.23-1.94-1.23-1.92 0Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M82.93 82.66c-.94-1.42-1.9-2.83-2.88-4.22v-3.7c0-.2-.1-.38-.27-.48l-.85-.42a.56.56 0 0 0-.8.33c-.1.44-.16.88-.2 1.33l-.38-.55c-.54-.76-1.09-1.54-1.74-2.17-.77-.75-1.6-.78-2.54-.34-4.27 2-8.08 5.24-11 8.9a.56.56 0 0 0 .11.86c.78.6 1.73.95 2.71 1.02-.46 1.93-.8 3.94-.82 5.88 0 1.2.9 1.27 1.85 1.34l.2.02 1.4.11c.18-1.6.46-3.19.85-4.75l-.29-.11c-.57-.29-.8-.91-.83-1.52-.01-.62.14-1.23.29-1.82l.05-.24.53-2.17c.12-.49.87-.28.75.2l-.47 1.92-.1.36-.11.5c.03.05.05.12.05.2 0 .04.01.09.04.13a.6.6 0 0 0 .24.18 1 1 0 0 0 .26.1l.2.05c.25-1.2.52-2.39.83-3.56.13-.49.88-.28.75.2a64.62 64.62 0 0 0-.78 3.34l-.01.07c.31-.02.63-.09.93-.2l.62-2.17c.1-.38.2-.75.32-1.13.13-.48.89-.27.75.2l-.32 1.15-.69 2.4a5.13 5.13 0 0 1-.66 1.52.93.93 0 0 1-.86.43.75.75 0 0 1-.12.03l-.31.02c-.12 1.6-.3 3.2-.57 4.78l1.38.11c1.14.1 2.28.17 3.42.18.15-.85.32-1.69.53-2.52h-.26c-.29.02-.58-.03-.85-.13a.6.6 0 0 1-.3-.35.43.43 0 0 1-.15-.43 13.85 13.85 0 0 1 3.53-7.34c.1-.42.8-.4.77.08V80.45a83.1 83.1 0 0 1-1.3 10.5c.79-.03 1.6-.13 2.22-.48.9-.5 1.07-1.5 1.23-2.43l.06-.37.71-3.82c.87.04 1.73-.09 2.55-.38a.56.56 0 0 0 .33-.81ZM63.45 81.6l.08-.1c.01.07.04.12.06.18l-.14-.08Zm6.42-3.57.05.04.02-.1-.07.06Zm7.08-2.01a124.33 124.33 0 0 1 1 1.36l.1.14c-.4-.47-.78-.97-1.1-1.5Zm1.96.83.05.06v-.17a.56.56 0 0 1-.05.1Z",
        "fill": "#FF8000"
      }
    }), h("path", {
      "attrs": {
        "d": "M50.8 64c-2.5.56-4.95 1.62-6.84 3.38a10.76 10.76 0 0 0-3.26 7.2c-.45 6.02 4.88 9.65 10.22 10.67 1.74.32 3.51.46 5.28.43 1.77-.03 3.58-.15 5.12-1.13 1.2-.75.09-2.66-1.11-1.9-1.42.9-3.22.85-4.85.83-1.67 0-3.34-.2-4.97-.6-2.75-.7-5.85-2.23-7.03-5-1.03-2.46-.41-5.75 1.16-7.85 1.64-2.18 4.28-3.33 6.87-3.9 1.38-.31.8-2.44-.58-2.13h-.01Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M61 83.23c-.11.29-.08.12.16.03a4.32 4.32 0 0 1 2.21.04c1.36.4 1.94-1.72.59-2.13-1.7-.51-4.33-.43-5.08 1.48-.22.55.24 1.2.77 1.35.62.18 1.13-.22 1.35-.77Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M60.18 83.2c.26.18.07.07.03-.22-.02-.23-.02-.47.01-.7.04-.34.17-.92.33-1.1.9-1.09-.65-2.65-1.56-1.56-1.16 1.4-1.58 4.28.08 5.48 1.15.83 2.25-1.08 1.11-1.9Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M60.18 85.1c.17-.1.01 0-.06 0h.33a3.3 3.3 0 0 1 1.23.44l.22.13c.16.12 0-.06.09.1.72 1.21 2.62.1 1.9-1.12-.8-1.34-3.43-2.3-4.82-1.44-1.2.74-.1 2.65 1.11 1.9ZM92.23 68.9c2.8 3.57 7.15 6.09 11.24 7.88 2 .88 4.09 1.65 6.25 2.03.87.17 1.75.25 2.64.24.57.02 1.13-.06 1.67-.23.6-.24.93-.76 1.41-1.15.9-.73-.38-2-1.27-1.28-.54.44-.72.79-1.46.84-.36.03-.73.03-1.1.01-.82-.05-1.63-.18-2.42-.37-2.01-.5-3.96-1.2-5.83-2.1-3.61-1.71-7.36-3.95-9.85-7.15-.72-.9-1.98.37-1.28 1.28Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M111.86 75.4c-.21-.1-.43-.17-.66-.19H111l.3.03a.3.3 0 0 1-.09-.02l.26.1c.37.26.36.44.27.25l.11.26a1.2 1.2 0 0 1-.06-.25l.04.3a1.17 1.17 0 0 1 0-.27l-.04.3c0-.04.02-.08.03-.11l-.11.26c0-.02.02-.04.03-.05a1.1 1.1 0 0 0-1.9-1.11c-.27.4-.27 1-.13 1.44.08.3.26.58.5.78.15.11.32.2.5.24.16.03.32.05.48.05l-.3-.03h.06l-.26-.1.05.02c.26.14.56.18.85.11.27-.08.5-.26.65-.5a1.1 1.1 0 0 0-.4-1.51Z",
        "fill": "#4C4C4C"
      }
    }), h("path", {
      "attrs": {
        "d": "M94.72 51.15s-.38-1.54-.2-2.06.41-1.14.95-1c.53.14 1.2.37.8 1.1-.4.73-1.55 1.96-1.55 1.96ZM98.01 53.3s.24-1.57.74-2.15c.5-.59 1.74-1.37 2.27-.64.53.73.28 1.8-.37 2.1-.64.28-2.22 0-2.64.7ZM98.62 56.34c.51-.52 1.24-.79 1.97-.71 1.23.13 1.95 1.12 1.77 1.68-.18.57-1.18 1-1.86.34-.68-.66-1.33-1.38-1.88-1.3ZM46.07 55.33s-.87-.74-1.64-.23c-.77.51-1.26 1.47-.83 1.87.43.4 1.07.39 1.45-.25.37-.63.52-1.36 1.02-1.39ZM46.18 52.23s-.7-1.4-1.46-1.65-2.2-.22-2.34.3c-.14.53-.11 1.05 1.04 1.27 1.15.22 2.35-.13 2.76.08ZM48.87 50.77c.08.27.33-1.66.11-2.14-.22-.48-.81-1.37-1.58-.88-.76.5-.62 1.03-.12 1.46.5.43 1.42 1.05 1.59 1.56Z",
        "fill": "#82C9E3"
      }
    }), h("path", {
      "attrs": {
        "d": "M115.36 60.41a684.4 684.4 0 0 1-5.15 27.03c-.12.5.15 1.1.7 1.23.5.11 1.1-.16 1.22-.7.75-3.44 1.45-6.88 2.13-10.33a675.58 675.58 0 0 0 3.03-16.7c.08-.51-.14-1.1-.7-1.23-.48-.11-1.14.15-1.23.7Z",
        "fill": "#BFCF8F"
      }
    }), h("ellipse", {
      "attrs": {
        "cx": "117.57",
        "cy": "50.71",
        "rx": "5.03",
        "ry": "4.64",
        "transform": "rotate(-4.03 117.57 50.7)",
        "fill": "#ED6065"
      }
    }), h("path", {
      "attrs": {
        "d": "M119.5 47.93c1.12.77 1.23 1.98 1.3 2.94a3.01 3.01 0 0 1-2.27 3.1c-1.24.4-2.73.16-3.6-.8-.88-.95-1-2.47-.52-3.69.15-.35.35-.68.58-.98 1.13-1.6 3-1.6 4.5-.57Z",
        "fill": "#FDDA24"
      }
    }), h("path", {
      "attrs": {
        "d": "M118.72 45.18c.15-1.13-.32-3.06-2.62-3.39-2.3-.33-2.95 1.22-3.13 2.74-.24 2.02.4 7.02 2.23 6.42 1.66-1.63 3.2-3.47 3.52-5.77Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M112.37 44.97c-.63-.8-2.11-1.63-3.56-.18-1.45 1.45-.82 2.85.05 3.9 1.15 1.4 3.75 4.67 5.28 2.3-.14-2.17-.48-4.39-1.77-6.02Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M108.85 49.12c-1.05-.33-2.87-.17-3.26 2.02-.4 2.18 1.03 3.06 2.45 3.46 1.9.55 4.34-.6 6.1-1.17-1.47-1.86-3.14-3.64-5.29-4.31Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M108.5 54.68c-.94.44-2.17 1.75-1.28 3.66.9 1.92 2.4 1.64 3.64 1.03 1.66-.81 3.93-2.72 3.78-4.86-2.06-.46-4.22-.73-6.14.17Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M111.61 59.29c-.45.99-.53 2.75 1.58 3.28 2.11.53 3.16-.78 3.75-2.11.79-1.78-.04-4.21-.38-5.94-2.03 1.28-4.01 2.75-4.95 4.77Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M118.26 59.89c.64.86 2.23 1.85 4 .55s1.18-2.78.3-3.93c-1.17-1.53-3.5-3.72-5.74-2.85-.04 2.2.13 4.46 1.44 6.23Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M122.98 55.55c1.14.08 3.02-.52 3.12-2.85.1-2.33-1.51-2.87-3.05-2.96-2.05-.1-4.44 1.66-6.2 2.66 1.8 1.56 3.8 2.98 6.13 3.15Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M122.77 49.4c.87-.67 1.8-2.27.25-3.87-1.54-1.6-3.85-.96-4.45.4-1.03 2.32-1.8 3.5-2.35 5.28 2.35-.12 4.76-.44 6.55-1.81Z",
        "fill": "#F0C7C7"
      }
    }), h("path", {
      "attrs": {
        "d": "M118.14 49.38c1.12.77 1.23 1.98 1.3 2.95a3 3 0 0 1-2.28 3.1c-1.24.38-2.72.15-3.6-.8-.87-.95-1-2.48-.52-3.7.16-.35.35-.68.59-.98 1.13-1.6 3-1.6 4.5-.57Z",
        "fill": "#FCCC75"
      }
    }), h("path", {
      "attrs": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M127.96 48.18c2 2.28-.02 5.84-2.87 5.72H125c.43.53.74 1.14.92 1.8.36 1.57-.8 2.95-2.22 3.48-1.39.51-2.78-.02-3.7-1.1a6.89 6.89 0 0 1-.25-.36 3.7 3.7 0 0 1-2.26 3.03c-1.25.55-3.07.23-3.97-.85a2.63 2.63 0 0 1-.52-2.12 4 4 0 0 1-1.7.37c-1.48-.04-2.48-1.38-2.71-2.76-.15-.94.15-1.9.8-2.58a3.54 3.54 0 0 1-1.8-1.51 3.65 3.65 0 0 1 .44-4.11c.57-.59 1.36-.9 2.17-.86-.6-.97-.88-2.05-.27-3.17 1.04-1.9 3.18-2.28 4.68-.94.24-1.6 1.01-3.05 2.92-3.1 2.05-.05 3.63 1.33 3.8 3.25.46-.28.98-.43 1.52-.44 1.51 0 2.87.92 3.41 2.33a2.87 2.87 0 0 1-.56 2.85c.85.1 1.7.44 2.25 1.07Zm-13.73 9.15c-.98 2.3 2.21 3.46 3.66 1.83.97-1.1 1.05-2.45.87-3.81-.09-.33-.15-.67-.2-1.01-.59.1-1.19.1-1.77-.03a9.02 9.02 0 0 0-2.56 3.02Zm-2.04-.39c-1.16.39-2.04-.13-2.44-1.3-.39-1.12.15-2.1 1.12-2.64a7.43 7.43 0 0 1 3.53-.5 3.28 3.28 0 0 0 1.23 1.34l.04.03c-.8.68-1.5 1.5-2.07 2.4-.44.28-.92.5-1.41.67Zm-1.29-9.44c-.87-.24-1.8-.1-2.31.72a2.36 2.36 0 0 0 .62 3.23c.41.27.87.45 1.36.54 1.1-.44 2.3-.63 3.48-.56a4.4 4.4 0 0 1 .08-1.8 8.49 8.49 0 0 0-3.23-2.13Zm3.17-4.35a8.65 8.65 0 0 1 1.52 4.15 4.4 4.4 0 0 0-1.05 1.28 9.93 9.93 0 0 0-2.8-1.88c-.4-.43-.71-.93-.94-1.47-.75-1.95 1.82-3.75 3.26-2.08Zm6.24-.2c.2-1.85-1.86-3.53-3.64-2.56l-.01.01c-1.01.54-1.13 1.98-1.08 3.16a9.71 9.71 0 0 1 1 3.11l.01.05a3.53 3.53 0 0 1 2.05-.12l.26-.36.07-.1.04-.06.38-.8a82.9 82.9 0 0 0 .74-1.53c.07-.26.13-.53.18-.8Zm4.24 3.86a8.47 8.47 0 0 1-3.5 1.42 3.55 3.55 0 0 0-.95-1.01 5.74 5.74 0 0 0-.36-.21c.1-.24.22-.47.33-.7.12-.25.24-.53.35-.82.31-.78.66-1.64 1.24-2.08 2.1-1.6 5.08 1.57 2.88 3.4h.01Zm-2.95 4.75a8.23 8.23 0 0 0 3.51 1.29h-.01c.88.01 1.76-.31 2.22-1.12.61-1.08.43-2.73-.77-3.3a3.59 3.59 0 0 0-2.1-.3 9.6 9.6 0 0 1-2.68 1.03l-.25.14c.22.74.25 1.51.08 2.26Zm-5.36 1.42c-1.57-.9-1.43-3.1-.46-4.38 1-1.33 2.45-1.29 3.77-.48a3.28 3.28 0 0 1 .8 3.82c-.75 1.4-2.79 1.8-4.12 1.04h.01Zm3.34 1.04c.13 1.21.55 2.37 1.22 3.38.9 1.12 2.38 1.2 3.45.22.94-.85.78-1.8.1-2.78-.32-.46-.69-.9-1.09-1.3-.72-.24-1.41-.57-2.06-.97l-.15.24c-.37.53-.88.95-1.47 1.21Z",
        "fill": "#FA8A99"
      }
    }), h("path", {
      "attrs": {
        "d": "M113.15 74.53c-.61.05-1.27.36-1.34.98-.03.2 0 .42.09.62-.54.04-.98.44-1.07.97-.1.6.28 1.78.85 1.51 1.03-.48 1.77.41 1.89.87.11.47 2.33.38 2.35-2.3a2.6 2.6 0 0 0-2.77-2.65Z",
        "fill": "#4C4C4C"
      }
    })]);
  }
};

export { BagSorryBgIcon as default };
